<div class="container">
  <div *ngIf="isLoading || savingInProgress">
    <progress-spinner></progress-spinner>
  </div>
  <div class="discover-content" *ngIf="!isLoading && !savingInProgress">
    <div *ngIf="showDiscoveyResTable">
      <div class="discover-description">
        Below are JMEPs that have been discovered using zero touch provisioning.
        You can delete an entry by selecting it and pressing REMOVE.
      </div>
      <div class="zero-discover-options discovery-res-container">
          <div class="state-container">
            <div class="discovery-state" *ngFor="let states of ztpDiscoverySates">
              {{states.title}}
              <span class="count-val" [ngClass]="states.stateClass">{{states.count}}</span>
            </div>
          </div>
          <div class="discovery-table" *ngIf="ztpJmepsTable?.columns?.length > 0">
            <viavi-table
              [tableConfigurations]="ztpJmepsTable"
              [isActionEnabled]="isCheckBoxEnabled"
              [showToolbar]="false"
            ></viavi-table>
          </div>
      </div>
    </div>
    <div class="discover-description msg-text-height" *ngIf="!showDiscoveyResTable">
      <p>No JMEPs were found using zero touch provisioning.</p>
    </div>
    <div class="dialog-action-cont">
      <button
        mat-button mat-raised-button
        *ngIf="showDiscoveyResTable"
        color="primary"
        [disabled]="!isRemoveActionDisabled || !hasReadWriteRole"
        (click)="removeDiscoverDetails()"
      >REMOVE
      </button>
      <button
        mat-button mat-raised-button
        (click)="closeModal()" class="plain-btn">CLOSE</button>
    </div>
  </div>
</div>
